import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
const ProductReviewImagesController = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductReviewImagesController.url(args, options),
    method: 'get',
})

ProductReviewImagesController.definition = {
    methods: ["get","head"],
    url: '/api/products/reviews/{lipscoreId}/images',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
ProductReviewImagesController.url = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { lipscoreId: args }
    }

    if (Array.isArray(args)) {
        args = {
            lipscoreId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        lipscoreId: args.lipscoreId,
    }

    return ProductReviewImagesController.definition.url
            .replace('{lipscoreId}', parsedArgs.lipscoreId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
ProductReviewImagesController.get = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductReviewImagesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
ProductReviewImagesController.head = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProductReviewImagesController.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
const ProductReviewImagesControllerForm = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductReviewImagesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
ProductReviewImagesControllerForm.get = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductReviewImagesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewImagesController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewImagesController.php:17
* @route '/api/products/reviews/{lipscoreId}/images'
*/
ProductReviewImagesControllerForm.head = (args: { lipscoreId: string | number } | [lipscoreId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductReviewImagesController.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ProductReviewImagesController.form = ProductReviewImagesControllerForm

export default ProductReviewImagesController